import { WorkdayLinkedService } from 'app/model/linkedservice/workday.linkedservice';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { AdapterRegistry, IModel, Metamodel, workdayAuthTypes } from 'shell-models-lib';
import { Model } from '../../backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from './azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(WorkdayLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                subDomain: '*',
                tenantId: '*',
                authenticationType: '*',
                userName: '*',
                password: 'secret',
                serviceVersion: '*',
                service: '*',
                operation: '*',
                encryptedCredential: '*'
            },
            parameters: '*'
        }
    }
})
export class WorkdayLinkedServiceAdapter extends LinkedServiceAdapter<WorkdayLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => WorkdayLinkedService {
        return WorkdayLinkedService;
    }

    protected model(): IModel {
        return WorkdayLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: WorkdayLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.WorkdayLinkedService;
        properties.type = Metamodel.modelFor(WorkdayLinkedService).name;
        if (linkedService.authenticationType === workdayAuthTypes.BASIC) {
            properties.typeProperties = {
                subDomain: this.valueToResource(linkedService, WorkdayLinkedService.SUBDOMAIN),
                tenantId: this.valueToResource(linkedService, WorkdayLinkedService.TENANT_ID),
                authenticationType: linkedService.authenticationType,
                userName: this.valueToResource(linkedService, WorkdayLinkedService.USER_NAME),
                password: parameterizablePasswordOrAKVtoSecretBase(linkedService, WorkdayLinkedService.PASSWORD, this.context),
                serviceVersion: this.valueToResource(linkedService, WorkdayLinkedService.SERVICE_VERSION),
                service: this.valueToResource(linkedService, WorkdayLinkedService.SERVICE),
                operation: this.valueToResource(linkedService, WorkdayLinkedService.OPERATION)
            };
        }
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: WorkdayLinkedService): Promise<WorkdayLinkedService> {
        const properties = linkedServiceResource.properties as Model.WorkdayLinkedService;
        const typeProperties = properties.typeProperties;
        ValueAdapter.toModel(linkedService, WorkdayLinkedService.SUBDOMAIN, typeProperties.subDomain);
        ValueAdapter.toModel(linkedService, WorkdayLinkedService.TENANT_ID, typeProperties.tenantId);
        linkedService.authenticationType = typeProperties.authenticationType as workdayAuthTypes;
        if (linkedService.authenticationType === workdayAuthTypes.BASIC) {
            ValueAdapter.toModel(linkedService, WorkdayLinkedService.USER_NAME, typeProperties.userName);
            parameterizableSecretBaseToModel(linkedService, WorkdayLinkedService.PASSWORD, typeProperties.password, this.context);
        }
        ValueAdapter.toModel(linkedService, WorkdayLinkedService.SERVICE_VERSION, typeProperties.serviceVersion);
        ValueAdapter.toModel(linkedService, WorkdayLinkedService.SERVICE, typeProperties.service);
        ValueAdapter.toModel(linkedService, WorkdayLinkedService.OPERATION, typeProperties.operation);
        return linkedService;
    }
}
